import type { TFunction } from "i18next";
import { z } from "zod";
import { meetsAllPasswordCriteria } from "./password-criteria";

// The design provides a single error message for the email field; it covers
// both the empty and the invalid-format case.
function emailSchema(t: TFunction<"auth">) {
  return z
    .string()
    .trim()
    .min(1, t("signIn.errors.emailRequired"))
    .email(t("signIn.errors.emailRequired"));
}

/** Messages come from the `auth` namespace, so the schemas are built per
 *  render with the active `t` — a static schema would freeze one language. */
export function createSignInSchema(t: TFunction<"auth">) {
  return z.object({
    email: emailSchema(t),
    password: z.string().min(1, t("signIn.errors.passwordRequired")),
  });
}

export type SignInInput = z.infer<ReturnType<typeof createSignInSchema>>;

export function createResetPasswordSchema(t: TFunction<"auth">) {
  return z.object({
    email: emailSchema(t),
  });
}

export type ResetPasswordInput = z.infer<
  ReturnType<typeof createResetPasswordSchema>
>;

// Shared by change-password and sign-up. No message: the live criteria
// checklist is the error display per design.
export const newPasswordSchema = z.object({
  password: z.string().refine(meetsAllPasswordCriteria),
});

export type NewPasswordInput = z.infer<typeof newPasswordSchema>;
